module.exports = __webpack_public_path__ + "01555d2.ttf";